import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ServicesHealthCheck } from '../models';

import { ApiService } from '../utils/api.service';

@Injectable()
export class HealthCheckService {

  path = 'health_checks';
  constructor(
    private apiService: ApiService,
  ) {
  }

  /**
   * Health check route that ensures that external services are up and running.
   */
  externalServices(): Observable<ServicesHealthCheck> {
    return this.apiService.get(`${this.path}/external_services`);
  }

  /**
   * Returns "pong" to a ping request to ensure that the API is running.
   */
  ping(): Observable<string> {
    return this.apiService.get(`${this.path}/ping`);
  }
}
